import type { HTMLAttributes } from 'react'
import { cn } from '../../lib/utils'

type Tone = 'neutral' | 'green' | 'yellow' | 'red' | 'blue' | 'ink'

const TONE_CLASSES: Record<Tone, string> = {
  neutral: 'bg-warm-mist text-text-dark',
  green: 'bg-matrix-green/20 text-ink border border-matrix-green/40',
  yellow: 'bg-gold/40 text-text-dark border border-gold',
  red: 'bg-coral/30 text-text-dark border border-coral',
  blue: 'bg-mint/30 text-text-dark border border-mint',
  ink: 'bg-ink text-text-on-dark',
}

interface BadgeProps extends HTMLAttributes<HTMLSpanElement> {
  tone?: Tone
}

export function Badge({ tone = 'neutral', className, ...props }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
        TONE_CLASSES[tone],
        className,
      )}
      {...props}
    />
  )
}
